import gql from 'graphql-tag';

export const GET_SUMMARY_TAGS = gql`
  query getSummaryTags {
    rows: ri_apps_prd_c_tags {
      c_tag_id
      title
    }
  }
`;

export const UPSERT_CAMPAIGN_SUMMARY_TAGS = gql`
  mutation UpsertCampaignSummaryTags($data: [ri_apps_prd_campaign_tags_insert_input!]!) {
    rows: insert_ri_apps_prd_campaign_tags(
      objects: $data
      on_conflict: { constraint: campaign_tags_pkey, update_columns: [c_tag_id, campaign_id] }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_CAMPAIGN_SUMMARY_TAGS = gql`
  mutation DeleteCampaignSummaryTags($campaignId: Int!, $summaryTagIds: [Int!]!) {
    rows: delete_ri_apps_prd_campaign_tags(
      where: { campaign_id: { _eq: $campaignId }, c_tag_id: { _in: $summaryTagIds } }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_CAMPAIGN_ORG_SUMMARY_TAGS = gql`
  mutation DeleteCampaignOrgSummaryTags($campaignId: Int!, $summaryTagIds: [Int!]!) {
    rows: delete_ri_apps_prd_campaign_tags(
      where: { campaign_id: { _eq: $campaignId }, o_tag_id: { _in: $summaryTagIds } }
    ) {
      affected_rows
    }
  }
`;

export const GET_ORG_SUMMARY_TAGS = gql`
  query GetOrganizationTags($organization_id: Int!) {
    rows: ri_apps_prd_org_tags(where: { organization_id: { _eq: $organization_id } }) {
      org_tag_id
      title
      organization_id
    }
  }
`;

export const CREATE_ORG_SUMMARY_TAGS = gql`
  mutation CreateOrganizationTag($data: [ri_apps_prd_org_tags_insert_input!]!) {
    row: insert_ri_apps_prd_org_tags(objects: $data) {
      affected_rows
      returning {
        org_tag_id
      }
    }
  }
`;

export const DELETE_ORG_SUMMARY_TAGS = gql`
  mutation DeleteOrganizationTags($tagIds: [Int!]!) {
    row: delete_ri_apps_prd_org_tags(where: { org_tag_id: { _in: $tagIds } }) {
      affected_rows
    }
  }
`;
